<button mat-icon-button>
  <mat-icon svgIcon="arrow-left" aria-hidden="true"></mat-icon>
</button>
